import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "16px",
    backgroundColor: "#092E79",
    padding: "64px 120px",
    [theme.breakpoints.down("md")]: {
      padding: "120px 40px",
    },
  },
  innerContainer: {
    display: "flex",
    justifyContent: "center",
  },
  wrapper: {
    width: "100%",
    maxWidth: "1200px",
  },
  remoLogo: {
    marginBottom: 40,
  },
  footerGrid: {
    display: "flex",
    gap: "24px",
    alignItems: "flex-start",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: "20px",
    },
  },
  logoColumn: {
    display: "flex",
    alignItems: "flex-start",
  },
  columnsContainer: {
    gap: "20px",
    display: "flex",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  columnDiv: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: "200px",
  },
  columnHeading: {
    marginBottom: "1rem",
    fontSize: "1.2rem",
    color: theme.palette.white,
    whiteSpace: "nowrap",
  },
  columnLinks: {
    cursor: "pointer",
    color: theme.palette.white,
    padding: 15,
    backgroundColor: "transparent",
    transition: "color .2s ease-in-out",
    textDecoration: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      color: theme.palette.blue.main,
    },
  },
  footerMain: {
    display: "grid",
    gridTemplateRows: "auto",
    gridTemplateColumns: "minmax(200px,1fr) minmax(100px,1fr)",
    gridGap: 16,
    gridAutoColumns: "1fr",
    [theme.breakpoints.down("lg")]: {
      gridGap: "30px 16px",
      gridTemplateColumns: "1fr 1fr",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  bottomWrapper: {
    padding: "30px 270px 0px",
    [theme.breakpoints.down("md")]: {
      height: 380,
    },
  },
  bottomContainer: {
    gridArea: "span 1/span 1/span 1/span 1",
  },
  certificateContainer: {
    maxHeight: "100%",
    minHeight: 100,
    minWidth: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      justifyContent: "space-around",
      alignItems: "normal",
    },
  },
  certificateImage: {
    width: 80,
    height: 80,
    gridGap: 16,
    objectFit: "contain",
    backgroundColor: theme.palette.white,
    borderRadius: 10,
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: 20,
    marginRight: 20,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: 60,
      height: 60,
      marginLeft: 5,
      marginRight: 5,
    },
  },
  ratingMainDiv: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  ratingDiv: {
    height: 170,
    color: theme.palette.white,
    textAlign: "center",
    borderRight: "1px #1a2945",
    alignSelf: "center",
    padding: "24px 10px",
    paddingTop: 37,
    position: "static",
    [theme.breakpoints.down("md")]: {
      paddingTop: 0,
      height: 80,
      padding: "24px 5px",
    },
    "& p": {
      fontSize: "12px !important",
      [theme.breakpoints.down("md")]: {
        fontSize: "10px !important",
      },
    },
    "& div": {
      padding: 12,
      display: "inline-block",
      [theme.breakpoints.down("sm")]: {
        padding: 0,
      },
    },
  },
  ratingBox: {
    cursor: "pointer",
    textDecoration: "none",
    color: "inherit",
  },
  paddingTop0: {
    paddingTop: 0,
  },
  ratingImage: {
    marginBottom: 16,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 8,
    },
  },
  image: {
    maxWidth: "100%",
    border: 0,
    verticalAlign: "middle",
  },
  compliant: {
    color: theme.palette.white,
    width: "50%",
    display: "block",
    position: "absolute",
    top: 130,
    left: 22,
    [theme.breakpoints.down("md")]: {
      top: 80,
      left: 5,
      fontSize: "11px !important",
      width: "100%",
    },
  },
  followUs: {
    padding: "0px 20px",
    color: theme.palette.white,
    [theme.breakpoints.down("md")]: {
      marginTop: 10,
      padding: "0px 5px",
    },
  },
  followUsText: {
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
    },
  },
  platforms: {
    width: "50%",
    display: "flex",
    justifyContent: "space-between",
  },
}));
